module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1019-edcf97e2076ccf82143b183417eb90ce.png";